/**
 * Registers public/sw.js, the (deliberately cache-free) service worker that makes the
 * web app installable on Chromium and gives an installed app an offline page.
 *
 * Production builds only: under the webpack dev server a service worker gets between HMR
 * and the page and is a well-known source of "my change is not showing up". Any worker
 * left behind from an earlier production visit to the same origin is removed in dev.
 */
export function registerServiceWorker(): void {
	if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

	if (process.env.NODE_ENV !== 'production') {
		navigator.serviceWorker
			.getRegistrations()
			.then(registrations => registrations.forEach(registration => registration.unregister()))
			.catch(() => {});
		return;
	}

	// Service workers need a secure context; http://<lan-ip> test rigs simply skip this.
	if (!window.isSecureContext) return;

	window.addEventListener('load', () => {
		navigator.serviceWorker
			// nginx serves sw.js with no-cache; this makes the browser honour that for updates.
			.register('/sw.js', { scope: '/', updateViaCache: 'none' })
			.catch(error => console.warn('[pwa] service worker registration failed:', error));
	});
}
